import axios from 'axios';
import useCurrentUser from '../hooks/useCurrentUser';
import { API_HOST } from '../constants/constants';
export const deleteContact = async (contactID) => {
  const apiURL = API_HOST + '/contacts/' + contactID;
  const { token, userID } = useCurrentUser();
  
  try {
    const { data } = await axios.delete(apiURL,{
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+token,
        'x-sb-user-id': userID
      }
    });
    return data.data;
  } catch (error) {
    console.error(error);
  }
};
